'use strict'

const union = require('folktale/adt/union/union')

const deriveMethods = require('dbsm-common/src/adt/deriveMethods')

const QueryResults = union('QueryResults', {
  Empty: () => ({}),
  Results: (items, totalCount, offset = 0) => ({ items, totalCount, offset })
})

deriveMethods(QueryResults, {
  chain: {
    Empty: function chain(fn) {
      return this
    },
    Results: function chain(fn) {
      return fn({
        items: this.items,
        totalCount: this.totalCount,
        offset: this.offset
      })
    }
  },

  map: {
    Empty: function map(fn) {
      return this
    },
    Results: function map(fn) {
      const { items, totalCount, offset } = fn({
        items: this.items,
        totalCount: this.totalCount,
        offset: this.offset
      })
      return QueryResults.Results(
        items || this.items,
        totalCount || this.totalCount,
        offset || this.offset
      )
    }
  },

  filter: {
    Empty: function filter(fn) {
      return this
    },
    Results: function filter(fn) {
      return fn({
        items: this.items,
        totalCount: this.totalCount,
        offset: this.offset
      })
        ? this
        : QueryResults.Empty()
    }
  },

  orElse: {
    Empty: function orElse(fn) {
      return fn()
    },
    Results: function orElse(fn) {
      return this
    }
  }
})

Object.assign(QueryResults, {
  of({ items, totalCount, offset }) {
    return totalCount > 0 && Array.isArray(items)
      ? QueryResults.Results(items, totalCount, offset)
      : QueryResults.Empty()
  },
  fromWixDataQueryResults(wixDataQueryResults, offset) {
    return wixDataQueryResults
      ? this.of({
          items: wixDataQueryResults.items,
          totalCount: wixDataQueryResults.totalCount,
          offset
        })
      : QueryResults.Empty()
  },

  get() {
    return this.matchWith({
      Empty: () => ({ items: [], totalCount: 0, offset: 0 }),
      Results: results => results
    })
  }
})

module.exports = QueryResults



// WEBPACK FOOTER //
// ./helpers/queryResults.js